module.exports = __webpack_public_path__ + "static/media/AdobeSign_Step3_Image23.5bdc7b75.jpg";